import * as React from 'react';
import s from './MessageBox.scss';
import { Text, Button } from 'wix-style-react';
import X from 'wix-ui-icons-common/X';
import { translate } from 'react-i18next';
var MessageBox = function (_a) {
    var onClose = _a.onClose, businessName = _a.businessName, t = _a.t, withInvoice = _a.withInvoice;
    return (React.createElement("div", { className: s.messageBox },
        React.createElement("div", { className: s.actions },
            React.createElement(X, { size: "18px", className: s.close, onClick: onClose })),
        React.createElement("div", { className: s.content },
            React.createElement("div", { className: s.contentTitle },
                React.createElement(Text, { className: s.titleText, weight: "bold", size: "tiny", secondary: false, light: false }, t('invoice-view:price-quote.dialog.title'))),
            React.createElement("div", { className: s.contentText },
                React.createElement(Text, null, t(withInvoice
                    ? 'invoice-view:price-quote.dialog.content-with-invoice'
                    : 'invoice-view:price-quote.dialog.content', { businessName: businessName }))),
            React.createElement("div", { className: s.actions },
                React.createElement(Button, { className: s.confirmButton, onClick: onClose }, t('invoice-view:price-quote.dialog.confirm'))))));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(MessageBox);
//# sourceMappingURL=MessageBox.js.map